export const NodeDashboardSharePermission = "NodeDashboardShare";
